import { render, staticRenderFns } from "./personnal.vue?vue&type=template&id=2ebaa694&scoped=true&"
import script from "./personnal.vue?vue&type=script&lang=js&"
export * from "./personnal.vue?vue&type=script&lang=js&"
import style0 from "./personnal.vue?vue&type=style&index=0&id=2ebaa694&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebaa694",
  null
  
)

export default component.exports